import { MemberadminTFunction } from '@dap/memberadmin/i18n';
import { CountryCode } from '@shared/types';
import { Validations } from '@dap/common/utils';

export function getOrgNumberNameFromCountry(countryCode: string, t: MemberadminTFunction) {
  return countryCode === CountryCode.Finland
    ? t('dataowner.organization.FONumber')
    : t('dataowner.organization.abbreviation');
}

export function getOrgNumberName(orgNumber: string | null, t: MemberadminTFunction) {
  if (!orgNumber) return t('dataowner.organization.abbreviation');
  if (Validations.finnishOrgNoRegex.test(orgNumber)) return t('dataowner.organization.FONumber');
  return t('dataowner.organization.abbreviation');
}
